import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateTimeMinuteFormatter } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

type MedicalImagingDetailsProps = {
   readonly medicalImaging: MedicalImaging;
};

export const MedicalImagingDetails = (props: MedicalImagingDetailsProps): JSX.Element => {
   const { medicalImaging } = props;

   return (
      <>
         <TextView
            testId={'procedure'}
            label={patientMedicalInformationTranslationKeys.medicalImaging.details.procedure}
         >
            {medicalImaging.icd9?.getCode().toString()}
            {' - '}
            {medicalImaging.icd9?.getName().toString()}
         </TextView>
         <TextView
            testId={'examinationDate'}
            label={patientMedicalInformationTranslationKeys.medicalImaging.details.examinationDate}
         >
            {medicalImaging.examinationDate ? dateTimeMinuteFormatter(medicalImaging.examinationDate) : '-'}
         </TextView>
      </>
   );
};
